import React from 'react';
import { Paper, Select, Stack, Title } from '@mantine/core';

interface MapFiltersProps {
  chns: string[];
  rhaTeams: string[];
  rha: string;
  chn: string;
  gender: string;
  userDefaultRha: string;
  userDefaultChn: string;
}

export default function MapFilters({
  chns,
  rhaTeams,
  rha,
  chn,
  gender,
  userDefaultRha,
  userDefaultChn,
}: MapFiltersProps) {

  const handleChange = (param: string, value: string | null) => {
    const url = new URL(window.location.href);
    if (value) {
      url.searchParams.set(param, value);
    } else {
      url.searchParams.delete(param);
    }
    window.location.href = url.toString();
  };
  
  const activeChn = chn || userDefaultChn;
  const activeRha = rha || userDefaultRha;

  return (
    <Paper
      pos="absolute"
      top={16}
      left={16}
      p="lg"
      radius="md"
      shadow="lg"
      style={{ zIndex: 1000, minWidth: 260 }}
    >
      <Stack gap="sm">
        <Title order={6} c="dimmed">
          Filters
        </Title>
        <Select
          label="Gender"
          placeholder="Select Gender"
          data={[
            { value: 'all', label: 'All Genders' },
            { value: 'male', label: 'Male' },
            { value: 'female', label: 'Female' },
            { value: 'other', label: 'Other' },
          ]}
          defaultValue={gender || null}
          onChange={(val) => handleChange('gender', val)}
          clearable
          searchable
          styles={{ dropdown: { zIndex: 1001 } }}
        />

        <Select
          label="CHN"
          placeholder="Select CHN"
          data={[
            ...chns.map((c) => ({ value: c, label: c })),
          ]}
          defaultValue={activeChn || null}
          onChange={(val) => handleChange('chn', val)}
          clearable
          searchable
          styles={{ dropdown: { zIndex: 1001 } }}
        />

        <Select
          label="RHA"
          placeholder="Select RHA"
          data={[
            ...rhaTeams.map((team) => ({ value: team, label: team })),
          ]}
          defaultValue={activeRha || null}
          onChange={(val) => handleChange('rha', val)}
          clearable
          searchable
          styles={{ dropdown: { zIndex: 1001 } }}
        />
      </Stack>
    </Paper>
  );
}